var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnitedStates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 29,
    height: 29,
    transform: "translate(4)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "united-states_1",
    "data-name": "united-states 1",
    transform: "translate(-4)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M18.5,29A14.5,14.5,0,1,0,4,14.5,14.5,14.5,0,0,0,18.5,29Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M17.87,14.5H33a14.514,14.514,0,0,0-.5-3.783H17.87Z",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M17.87,6.935h13a14.575,14.575,0,0,0-3.346-3.783H17.87Z",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M18.5,29a14.438,14.438,0,0,0,9.026-3.152H9.474A14.438,14.438,0,0,0,18.5,29Z",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M6.128,22.065H30.872A14.415,14.415,0,0,0,32.5,18.283H4.5a14.414,14.414,0,0,0,1.629,3.783Z",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M10.717,2.264h1.321l-1.229.893.47,1.445-1.229-.893L8.82,4.6l.406-1.248A14.58,14.58,0,0,0,6.414,6.488h.423l-.782.568q-.183.305-.351.62l.374,1.15-.7-.506q-.26.551-.474,1.126l.412,1.267H6.837l-1.229.893.469,1.445-1.229-.893-.736.535A14.639,14.639,0,0,0,4,14.5H18.5V0a14.431,14.431,0,0,0-7.783,2.264Zm.562,10.786-1.229-.893L8.82,13.05l.469-1.445-1.229-.893H9.58l.469-1.445.469,1.445h1.519l-1.229.893Zm-.47-5.669.47,1.445-1.229-.893L8.82,8.826,9.29,7.381,8.061,6.488H9.58l.469-1.445.469,1.445h1.519Zm5.671,5.669-1.229-.893-1.229.893.469-1.445-1.229-.893h1.519l.469-1.445.469,1.445h1.519l-1.229.893ZM16.01,7.381l.469,1.445L15.25,7.933l-1.229.893.469-1.445-1.229-.893h1.519l.469-1.445.469,1.445h1.519Zm0-4.224L16.479,4.6,15.25,3.709,14.021,4.6l.469-1.445-1.229-.893h1.519L15.25.82l.469,1.445h1.519Z",
    fill: "#0052b4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedStates);
export default __webpack_public_path__ + "static/media/united-states.f63311ba85617ea0a726f8a86ae17e39.svg";
export { ForwardRef as ReactComponent };